export default function PersonalizedLinkIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_4565_6408'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4565_6408)'>
        <path
          d='M17.6694 15.6443C17.6694 17.2683 17.1043 18.6502 15.9741 19.79C14.8441 20.93 13.4685 21.5 11.8474 21.5C10.2262 21.5 8.84896 20.93 7.71562 19.79C6.58229 18.6502 6.01562 17.2683 6.01562 15.6443V6.65375C6.01562 5.49992 6.41629 4.51917 7.21763 3.7115C8.01879 2.90383 8.99629 2.5 10.1501 2.5C11.304 2.5 12.2815 2.90383 13.0829 3.7115C13.8842 4.51917 14.2849 5.49992 14.2849 6.65375V15.1635C14.2849 15.8403 14.0491 16.4182 13.5776 16.897C13.106 17.3758 12.5313 17.6152 11.8536 17.6152C11.1758 17.6152 10.5975 17.3775 10.1186 16.902C9.63979 16.4265 9.40038 15.847 9.40038 15.1635V6.38475H10.9001V15.1635C10.9001 15.4315 10.9902 15.6572 11.1704 15.8405C11.3505 16.0238 11.5746 16.1155 11.8426 16.1155C12.1105 16.1155 12.3345 16.0238 12.5146 15.8405C12.6948 15.6572 12.7849 15.4315 12.7849 15.1635V6.64425C12.7745 5.90575 12.518 5.28042 12.0154 4.76825C11.5127 4.25608 10.891 4 10.1501 4C9.41246 4 8.78896 4.25767 8.27962 4.773C7.77029 5.2885 7.51562 5.91542 7.51562 6.65375V15.6443C7.50529 16.8533 7.92321 17.8814 8.76938 18.7288C9.61554 19.5763 10.6427 20 11.8509 20C13.0419 20 14.0543 19.5763 14.8881 18.7288C15.7218 17.8814 16.1489 16.8533 16.1694 15.6443V6.38475H17.6694V15.6443Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
